import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { retry } from 'rxjs';

import { LocalStorageService } from 'src/app/connectors/localstorage';
import { LogsService } from '../services/logs.service';
import { CreateLog } from '../models/request/create-log.model';
import { environment } from '@environments/environment';

export const createLogResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  // 1. Injeção de dependência deve ser síncrona (dentro do contexto de injeção)
  const localStorageService = inject(LocalStorageService);
  const logsService = inject(LogsService);

  // // Se não for produção, libera imediatamente sem agendar nada
  // if (!environment.production) {
  //   return true;
  // }

  setTimeout(() => {
    try {
      const userId = Number(localStorageService.decryptAndGet('userId'));

      // Validação simples dentro do timeout
      if (!userId || userId < 0) {
        return;
      }

      const params: CreateLog = {
        userId,
        pagePath: route.data['pagePath'] || route.routeConfig?.path || route.url[0]?.path || 'unknown-path'
      };

      logsService
        .createLog(params)
        .pipe(retry(3))
        .subscribe({
          error: (err) => console.error('Background logging failed', err)
        });
    } catch (e) {
      console.warn('Erro ao tentar gerar log no resolver', e);
    }
  }, 0);

  return true;
};
